/*
 * The `[zplayer]` two-pane playlist player (snippets/zg-playlist-player.liquid).
 *
 * Live's plugin page keeps a YouTube IFrame-API player object alive and calls
 * `player.playVideoAt(i)` on a click. That needs the API script and, for the
 * title list, a Data API key — neither of which survives cutover. The same
 * visible behaviour needs nothing but a src swap: point the one iframe at
 * `embed/<id>?autoplay=1` and the video changes in place, with no page reload
 * and no third-party script until the visitor asks for a video.
 *
 * The first item is `is-active` from Liquid, matching live, whose
 * `onPlayerReady` sets `video0` to `ytactive`.
 */
(() => {
  const ACTIVE = 'is-active';
  const EMBED = 'https://www.youtube.com/embed/';

  const enhance = (root) => {
    if (root.dataset.zgPlaylistReady === '1') return;
    root.dataset.zgPlaylistReady = '1';

    const frame = root.querySelector('[data-zg-playlist-frame]');
    if (!frame) return;

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-zg-playlist-video]');
      if (!button || !root.contains(button)) return;

      const videoId = button.dataset.zgPlaylistVideo;
      if (!videoId) return;

      for (const other of root.querySelectorAll('[data-zg-playlist-video]')) {
        const current = other === button;
        other.classList.toggle(ACTIVE, current);
        other.setAttribute('aria-current', current ? 'true' : 'false');
      }

      // autoplay=1 because the visitor has just asked for this video; without
      // it the swap would show a poster and need a second click, which live
      // does not.
      frame.src = `${EMBED}${encodeURIComponent(videoId)}?rel=0&playsinline=1&autoplay=1`;
      frame.title = button.textContent.trim();
    });
  };

  const run = () => {
    for (const root of document.querySelectorAll('[data-zg-playlist]')) enhance(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
